import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import RadioInput from '../../../../components/form/RadioInput'
import { PORTABILITE_FIELDS } from '../services/portabiliteConstants'
import { FormattedMessage, useIntl } from 'react-intl'
import DatePickerInput from '../../../../components/form/DatePickerInput'
import FileInput from '../../../../components/fileInput/FileInput'
import ButtonDefault from '../../../../components/ButtonDefault'
import ConfirmationPopin from '../../../../components/ConfirmationPopin'
import { useBreakpoints } from '../../../../components/breakpoints/BreakpointsProvider'
import ContactService from '../../../../api/gerep/ContactService'
import LocalStorage from '../../../../business/storage/LocalStorage'
import { ToastContext } from '../../../../components/toast/ToastContext'
import { ToastType } from '../../../../components/toast/toastConstants'
import { isAfter, isBefore, isEqual, isValid, subDays } from 'date-fns'
import SelectInput from '../../../../components/form/SelectInput'
import appConst from '../../../../constant/appConstants'
import { cardiboxActions, cardiboxSelectors } from 'redux-cardibox'
import { connect } from 'react-redux'
import { getGarantieEnVigueur } from '../../../webservices/contrats/contratsSelector'

const PortabiliteForm: React.FC = ({
    // @ts-ignore
    motifs,
    // @ts-ignore
    garantie,
    // @ts-ignore
    getValueListByShortcut,
    // @ts-ignore
    getArticleByShortcut,
    // @ts-ignore
    portabiliteFormQuestion1Non
}) => {
    const intl = useIntl()
    const { isMobile, isTabletPortrait } = useBreakpoints()
    const { addToast } = useContext(ToastContext)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [openConfirmation, setOpenConfirmation] = useState<boolean>(false)
    const [motifsFinPortabilite, setMotifsFinPortabilite] = useState<[]>([])

    useEffect(() => {
        getValueListByShortcut(appConst.cardiboxApi, 'motifs_fin_portabilite')
        getArticleByShortcut(appConst.cardiboxApi, 'portabiliteForm_question1_non')
    }, [])

    useEffect(() => {
        motifs && setMotifsFinPortabilite(motifs.entries.map((item: any) => {
            return {
                label: item.label,
                value: item.code
            }
        }))
    }, [motifs])

    const PORTABILITE_CHOICE = [
        {
            value: 'oui',
            label: 'Oui'
        },
        {
            value: 'non',
            label: 'Non'
        }
    ]

    const MAINTENIR_PORTABILITE = [
        {
            value: '1',
            label: intl.formatMessage({ id: 'portabilite.input.maintienOuFin.maintien' })
        },
        {
            value: '0',
            label: intl.formatMessage({ id: 'portabilite.input.maintienOuFin.fin' })
        }
    ]

    const onSubmit = (values: any) => {
        const {
            couvertureANI,
            maintenirPortabilite,
            dateDebut,
            dateFin,
            files,
            motif
        } = values

        let body
        if (couvertureANI === 'oui' && maintenirPortabilite === '0') {
            body = [{
                key: 'prolongation',
                value: {
                    couvertureANI: true,
                    finPortabilite: true,
                    dateFin: new Date(dateFin).toLocaleDateString('fr-FR'),
                    motif
                }
            }, []]
        } else {
            const filesUploaded = (
                couvertureANI ? files.map((file: any, index: number) => ({
                    key: `file${index}`,
                    value: file
                })) : []
            )

            body = [{
                key: 'prolongation',
                value: {
                    couvertureANI: couvertureANI === 'oui',
                    dateDebut: new Date(dateDebut).toLocaleDateString('fr-FR')
                }
            }, ...filesUploaded]
        }

        setIsLoading(true)
        return ContactService.prolongationCouvertureANI(LocalStorage.getToken(), body)
            .then(() => {
                setOpenConfirmation(true)
                addToast(ToastType.SUCCESS, 'global.success')
            })
            .catch((e) => {
                const error = 'Echec de la demande de prolongation de votre couverture ANI'
                if (e?.data?._error) {
                    addToast(ToastType.ERROR, e.data._error)
                } else if (e?.data) {
                    return e.data
                } else {
                    addToast(ToastType.ERROR, '', error)
                }
            })
            .finally(() => setIsLoading(false))

    }

    const handleResetFields = (values: any, change: (name: any, value?: any) => void) => {
        values[PORTABILITE_FIELDS.DATE_DEBUT] && change(PORTABILITE_FIELDS.DATE_DEBUT, undefined)
        values[PORTABILITE_FIELDS.DATE_FIN] && change(PORTABILITE_FIELDS.DATE_FIN, undefined)
        values[PORTABILITE_FIELDS.FILES] && change(PORTABILITE_FIELDS.FILES, undefined)
        values[PORTABILITE_FIELDS.MOTIF] && change(PORTABILITE_FIELDS.MOTIF, undefined)
    }

    return (
        <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
                const mettreFinPortabilite = values[PORTABILITE_FIELDS.COVER] === 'oui' && values[PORTABILITE_FIELDS.MAINTENIR_PORTABILITE] === '0'

                const errors: any = {}
                if (!values[PORTABILITE_FIELDS.COVER]) {
                    errors[PORTABILITE_FIELDS.COVER] = intl.formatMessage({ id: 'global.error.required' })
                }

                if (!mettreFinPortabilite) {
                    if (!values[PORTABILITE_FIELDS.DATE_DEBUT]) {
                        errors[PORTABILITE_FIELDS.DATE_DEBUT] = intl.formatMessage({ id: 'global.error.required' })
                    } else if (!isValid(values[PORTABILITE_FIELDS.DATE_DEBUT])) {
                        errors[PORTABILITE_FIELDS.DATE_DEBUT] = intl.formatMessage({ id: 'global.error.invalidDate' })
                    }
                } else {
                    const todayMinus90 = subDays(new Date(), 90)
                    const dateFin = values[PORTABILITE_FIELDS.DATE_FIN]
                    const garantieDebut = garantie.dateDebut
                    const garantieFin = garantie.dateFin

                    if (!dateFin) {
                        errors[PORTABILITE_FIELDS.DATE_FIN] = intl.formatMessage({ id: 'global.error.required' })
                    } else if (!isValid(dateFin)) {
                        errors[PORTABILITE_FIELDS.DATE_FIN] = intl.formatMessage({ id: 'global.error.invalidDate' })
                    } else {
                        if (isAfter(new Date(garantieDebut), todayMinus90)) {
                            // Garantie début > today - 90 jours
                            if (isBefore(dateFin, new Date(garantieDebut))) {
                                errors[PORTABILITE_FIELDS.DATE_FIN] = intl.formatMessage({ id: 'portabilite.input.finPortabilite.tooFar90Day' })
                            }
                        } else {
                            // Garantie début < today - 90 jours
                            if (garantieFin && isEqual(dateFin, new Date(garantieFin).setHours(0, 0, 0, 0))) {
                                errors[PORTABILITE_FIELDS.DATE_FIN] = intl.formatMessage({ id: 'portabilite.input.finPortabilite.allreadySave' })
                            } if (isBefore(dateFin, todayMinus90)) {
                                errors[PORTABILITE_FIELDS.DATE_FIN] = intl.formatMessage({ id: 'portabilite.input.finPortabilite.tooOld90Day' })
                            }
                        }

                        // Date fin doit être strictement < garantieFin
                        if (garantieFin && isEqual(dateFin, new Date(garantieFin))) {
                            errors[PORTABILITE_FIELDS.DATE_FIN] = intl.formatMessage({ id: 'portabilite.input.finPortabilite.allreadySave' })
                        } else if (garantieFin && isAfter(dateFin, new Date(garantieFin))) {
                            errors[PORTABILITE_FIELDS.DATE_FIN] = intl.formatMessage({ id: 'portabilite.input.finPortabilite.afterEndDate' })
                        }
                    }
                }

                if (!mettreFinPortabilite && (!values[PORTABILITE_FIELDS.FILES] || values[PORTABILITE_FIELDS.FILES]?.length === 0)) {
                    errors[PORTABILITE_FIELDS.FILES] = intl.formatMessage({ id: 'global.error.required' })
                }

                if (mettreFinPortabilite && !values[PORTABILITE_FIELDS.MOTIF]) {
                    errors[PORTABILITE_FIELDS.MOTIF] = intl.formatMessage({ id: 'global.error.required' })
                }

                return errors
            }}
            render={({ handleSubmit, values, form: { reset, change }, pristine, errors, touched }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        <Stack direction="column" spacing="24px">
                            <RadioInput
                                name={PORTABILITE_FIELDS.COVER}
                                error={(touched && touched[PORTABILITE_FIELDS.COVER] && errors) ? errors[PORTABILITE_FIELDS.COVER] : undefined}
                                data={PORTABILITE_CHOICE}
                                direction="row"
                                label={intl.formatMessage({ id: 'portabilite.input.already' })}
                                onChange={() => handleResetFields(values, change)}
                            />
                            {values[PORTABILITE_FIELDS.COVER] === 'oui' && (
                                <Stack direction="column" spacing="24px">
                                    <RadioInput
                                        name={PORTABILITE_FIELDS.MAINTENIR_PORTABILITE}
                                        error={(touched && touched[PORTABILITE_FIELDS.MAINTENIR_PORTABILITE] && errors) ? errors[PORTABILITE_FIELDS.MAINTENIR_PORTABILITE] : undefined}
                                        data={MAINTENIR_PORTABILITE}
                                        direction="row"
                                        defaultValue={'O'}
                                        radioSpacing="48px"
                                        label={intl.formatMessage({ id: 'portabilite.input.maintienOuFin.libelle' })}
                                        onChange={() => handleResetFields(values, change)}
                                    />

                                    {values[PORTABILITE_FIELDS.MAINTENIR_PORTABILITE] === '1' && (
                                        <>
                                            <Stack direction="column" spacing="12px">
                                                <Typography variant="body2">
                                                    <FormattedMessage id="portabilite.input.lastDay.description" />
                                                </Typography>
                                                <DatePickerInput
                                                    maxWidth="unset"
                                                    name={PORTABILITE_FIELDS.DATE_DEBUT}
                                                    label={intl.formatMessage({ id: 'portabilite.input.lastDay.label' })}
                                                />
                                            </Stack>

                                            <FileInput
                                                name={PORTABILITE_FIELDS.FILES}
                                                label={
                                                    <Stack direction="column" spacing="12px">
                                                        <Typography variant="body2">
                                                            <FormattedMessage id="portabilite.input.file.label" />
                                                        </Typography>
                                                        <Typography variant="body2" color="secondary">
                                                            <FormattedMessage id="portabilite.input.file.warning" />
                                                        </Typography>
                                                    </Stack>
                                                }
                                                title={intl.formatMessage({ id: 'portabilite.input.file.title' })}
                                            />
                                        </>)
                                    }
                                    { values[PORTABILITE_FIELDS.MAINTENIR_PORTABILITE] === '0' && (
                                        <Stack direction="column" spacing="32px">
                                            <DatePickerInput
                                                maxWidth="unset"
                                                name={PORTABILITE_FIELDS.DATE_FIN}
                                                label={intl.formatMessage({ id: 'portabilite.input.finPortabilite.label' })}
                                            />

                                            <SelectInput
                                                name={PORTABILITE_FIELDS.MOTIF}
                                                data={motifsFinPortabilite}
                                                label={intl.formatMessage({ id: 'portabilite.input.motif.label' })}
                                                mandatory
                                            />
                                        </Stack>
                                    )}
                                </Stack>
                            )}

                            {values[PORTABILITE_FIELDS.COVER] === 'non' && (
                                <Stack direction="column" spacing="24px">
                                    <Stack direction="column" spacing="12px">
                                        <Typography variant="body2">
                                            <div dangerouslySetInnerHTML={{__html: portabiliteFormQuestion1Non.fields.body}}/>
                                        </Typography>
                                        <DatePickerInput
                                            maxWidth="unset"
                                            name={PORTABILITE_FIELDS.DATE_DEBUT}
                                            label={intl.formatMessage({ id: 'portabilite.input.endDay.label' })}
                                        />
                                    </Stack>

                                    <FileInput
                                        name={PORTABILITE_FIELDS.FILES}
                                        label={intl.formatMessage({ id: 'portabilite.input.filePoleEmploi.label' })}
                                        title={intl.formatMessage({ id: 'portabilite.input.filePoleEmploi.title' })}
                                        error={errors && errors[PORTABILITE_FIELDS.FILES]}
                                    />
                                </Stack>
                            )}

                            {values[PORTABILITE_FIELDS.COVER] && (
                                <Typography variant="body2">
                                    <FormattedMessage id="portabilite.info" />
                                </Typography>
                            )}

                            <Stack alignItems="center">
                                <ButtonDefault
                                    variant="contained"
                                    onClick={handleSubmit}
                                    type="submit"
                                    disabled={pristine}
                                >
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> :
                                        <FormattedMessage id="global.button.validate" />}
                                </ButtonDefault>
                                <Box display="flex" width="100%" flex={1}
                                     alignSelf={isMobile || isTabletPortrait ? 'unset' : 'baseline'}>
                                    <Typography sx={{
                                        position: isMobile || isTabletPortrait ? 'unset' : 'relative',
                                        bottom: '32px',
                                        left: 0,
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'flex-end'
                                    }} variant="body2" color="#7a7a7a">
                                        <FormattedMessage id="global.mandatory" />
                                    </Typography>
                                </Box>
                            </Stack>

                            <ConfirmationPopin
                                title={intl.formatMessage({ id: 'portabilite.title' })}
                                open={openConfirmation}
                                setOpen={setOpenConfirmation}
                                resetForm={reset}
                            />
                        </Stack>
                    </form>
                )
            }}
        />
    )
}

const mapStateToProps = (state: any) => ({
    motifs: cardiboxSelectors.valuelists.getByShortcut(state.cardibox).motifs_fin_portabilite,
    garantie: getGarantieEnVigueur(state),
    portabiliteFormQuestion1Non: cardiboxSelectors.articles.getByShortcut(state.cardibox)['portabiliteForm_question1_non']
})

const actions = {
    getValueListByShortcut: cardiboxActions.valuelists.getByShortcut,
    getArticleByShortcut: cardiboxActions.articles.getByShortcut
}

export default connect(
    mapStateToProps,
    actions
)(PortabiliteForm)
